type Row = Record<string, unknown>;
const windows = new WeakSet<object>();

/** Only newly allocated rule windows enter this mode. Their mutable clusters
 * belong to the action; saved rows, inventory and definitions remain reads.
 * Nothing marks the held actor or escapes into the installed computed output. */
export function ownRuleWindow<T extends Row>(row: T): T {
    windows.add(row);
    return row;
}

export function isOwnedRuleWindow(value: unknown): boolean {
    return value !== null && typeof value === 'object' && windows.has(value);
}
